import { useContext, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppContext from "../../../context";

import Loading from "../../components/Loading";

import Item from './components/Item';

import Data from '../../../repository';

import styles from '../../../styles/Admin.module.scss';

function List() {
	const context = useContext(AppContext);
	const [loading, setLoading] = useState(true);
	const [products, setProducts] = useState([]);
	const [showArchived, setShowArchived] = useState(false);
	const [archiveLoadingId, setArchiveLoadingId] = useState(null);
	const [enableLoadingId, setEnableLoadingId] = useState(null);
	const showTokenType = context.domain?.businessType === 'hybrid-new';

	useEffect(async () => {
		await refreshProducts();
	}, [showArchived])

	const refreshProducts = async () => {
		setLoading(true);
		let products = showArchived
			? await Data.fetchArchivedProducts()
			: await Data.fetchProducts();
		products = products.data.sort((a, b) => {
			if (showArchived) {
				return new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt);
			}
			return b.enabled - a.enabled;
		})
		setProducts(products);
		setLoading(false);
	}

	const toggleArchive = async (productId, archived) => {
		if (archived) {
			const confirmed = window.confirm('Deactivate this product? It will be hidden from all lists and cannot be purchased.');
			if (!confirmed) return;
		}
		setArchiveLoadingId(productId);
		try {
			await Data.updateProduct({ _id: productId, archived });
			await refreshProducts();
		} catch (error) {
			console.error('Failed to update product', error);
		} finally {
			setArchiveLoadingId(null);
		}
	}

	const toggleEnabled = async (productId, enabled) => {
		setEnableLoadingId(productId);
		try {
			await Data.updateProduct({ _id: productId, enabled });
			await refreshProducts();
		} catch (error) {
			console.error('Failed to update product status', error);
		} finally {
			setEnableLoadingId(null);
		}
	}

	if(loading) return <Loading button={false} />

	return (
		<div className={styles.list}>
			<div className={styles.actions}>
				<button
					type="button"
					className={showArchived ? "btn btnEmpty" : "btn btnPrimary"}
					onClick={() => setShowArchived(false)}
				>
					Active
				</button>
				<button
					type="button"
					className={showArchived ? "btn btnPrimary" : "btn btnEmpty"}
					onClick={() => setShowArchived(true)}
				>
					Archived
				</button>
			</div>

			{!products.length && <div><p>There aren't any products to show.</p></div>}

			{!!products.length && (
				<div className={styles.tableWrap}>
					<table className={styles.table}>
						<thead>
							<tr>
								<th>Product</th>
								<th>Price</th>
								<th>Tokens</th>
								<th>Purchase Type</th>
								<th>Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{products.map((product) => (
								<Item
									key={product._id}
									{...product}
									onArchive={toggleArchive}
									onToggleEnabled={toggleEnabled}
									showTokenType={showTokenType}
									loading={archiveLoadingId === product._id}
									enableLoading={enableLoadingId === product._id}
								/>
							))}
						</tbody>
					</table>
				</div>
			)}
		</div>
	)
}

export default List;
